/** @format */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useMemo, useEffect, useState } from "react";
import { HomePage } from '../../styles/common.style';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { Form } from 'react-bootstrap';
import { GetMusclesList, GetPainPointList, GetEdVideoList } from "../../actions/user_program";
import { connect } from "react-redux";
import { cross_origin } from "../../utils/constants";
import { setAlert } from "../../actions/alert";
import BreadcrumbMenu from "./BreadcrumbMenu";
import CustomVideoPlayer from './AssessmentTimer/CustomVideoPlayer';
import { MdLock } from "react-icons/md";
import Slider from 'react-slick';
import Modal from "react-bootstrap/Modal";

const AboutNewTwo = ({ getEducationalVideos, educational_video }) => {
  const [itemsPerPage, setItemsPerPage] = useState(12);
  const [loader, setLoader] = useState(true);
  const [musclesAnatomyData, setMusclesAnatomyData] = useState([]);
  const [tempMusclesAnatomyData, setTempMusclesAnatomyData] = useState([]);

  const [painPointData, setPainPointData] = useState(null);
  const [tempPainPointAnatomyData, setTempPainPointAnatomyData] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  let navigate = useNavigate();
  const location = useLocation();
  const [currentPlayingVideo, setCurrentPlayingVideo] = useState(null);


  const handleVideoPlay = (videoKey) => {
    setCurrentPlayingVideo(videoKey);
  };

  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Educational Videos', link: '#', isActive: true }
  ];

  const settingsEducational = useMemo(() => ({
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  }), []);

  useEffect(() => {
    const scrollToHash = () => {
      if (location.hash) {
        const id = location.hash.replace("#", "");
        const el = document.getElementById(id);

        if (el) {
          // Increased offset to account for fixed header and any other elements
          const yOffset = -100; // Increased offset for better positioning
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

          // Use requestAnimationFrame for smoother scrolling
          requestAnimationFrame(() => {
            window.scrollTo({
              top: y,
              behavior: "smooth"
            });
          });
        }
      }
    };

    // Increased timeout to ensure DOM and images are fully loaded
    const timeout = setTimeout(scrollToHash, 500);

    return () => clearTimeout(timeout);
  }, [location]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  //   }, 100);
  // }, []);

  useEffect(() => {
    getMusclesList(itemsPerPage)
    getPainPointList(itemsPerPage)
  }, []);

  const edVideos = [
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/1.+Ed+Video+Bulgarian+Split+Squat+Glute+Focused+Dumbbells+Ed+M+Com.mp4' },
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/2.++Ed+Video+Psoas+Release+Ed+Video+F+Com.mp4' },
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/3.++Ed+Video+Glute+Bridge+L1+Ed+F+Com+Apt+Only+(1)+COM.mp4' },
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/4.+Ed+Video+Vastus+Lateralis+Release+Foam+Roller+L1+Ed+M+Com.mp4' },
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/5.+Ed+Video+Multifidi+COM.mp4' },
    { src: 'https://d1rs42xew6aaeb.cloudfront.net/Home+Page+Videos/Education+Videos/6.+Nordic+Curl+Explanation+COM.mp4' }
  ];

  const getMusclesList = async (itemsPerPage) => {

    await GetMusclesList(itemsPerPage)
      .then((result) => {
        if (result.status) {
          if (result.data) {
            setMusclesAnatomyData(result.data);
            setTempMusclesAnatomyData(result.data)
          }
        } else {
          return setAlert(result.message, "danger");
        }
      })
      .catch((error) => {
        setAlert(error.response.data.message.replace(/_/g, " "), "danger");
      });
  };

  const getPainPointList = async (itemsPerPage) => {
    await GetPainPointList(itemsPerPage)
      .then((result) => {
        if (result.status) {
          if (result.data) {
            setPainPointData(result.data);
            setTempPainPointAnatomyData(result.data)
          }
        } else {
          return setAlert(result.message, "danger");
        }
      })
      .catch((error) => {
        setAlert(error.response.data.message.replace(/_/g, " "), "danger");
      });
  };

  const handleSearchClick = (value) => {
    if (value.length < 1) {
      // Reset to show all records
      setMusclesAnatomyData(tempMusclesAnatomyData);
    } else {
      // Search only in the first 8 records
      const searchBase = tempMusclesAnatomyData.slice(0, 8);

      const searchResults = searchBase.filter((data) =>
        data.title.toLowerCase().includes(value.toLowerCase())
      );

      setMusclesAnatomyData(searchResults);
    }
  };

  const handleSearchClickPain = (value) => {
    if (value.length < 1) {
      // Reset to all 12 records
      setPainPointData(tempPainPointAnatomyData);
    } else {
      // Search only in first 8 records
      const searchBase = tempPainPointAnatomyData.slice(0, 8);

      const searchResults = searchBase.filter((data) =>
        data.title.toLowerCase().includes(value.toLowerCase())
      );

      setPainPointData(searchResults);
    }
  };


  const handleLoginPurchase = () => {
    setShow(true);
  }

  return (
    <>
      <HomePage>
        <div className='about-main-learn-main' style={{ scrollBehavior: 'smooth' }}>

          <section id="section1" className='about-top about-top-second common-padding-about'>
            <div className='common-container'>
              <div className='row align-items-center'>
                <div className='col-12 col-lg-8 col-md-8'>
                  <BreadcrumbMenu
                    breadcrumbs={breadcrumbs}
                    classNames={"breadcrumb-block"}
                  />
                </div>
              </div>
              <div className='about-top-inner'>
                <div className='about-top-inner-left'>
                  <h2 className='theme-color'>Education</h2>
                  <h3>
                    Each Program includes <span>Educational Videos</span> that :
                  </h3>
                  <ul>
                    <li>Demonstrate how to do the movements correctly </li>
                    <li>Common mistakes</li>
                    <li>Explains why this exercise is important for your BODY TYPE </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <section className='video-block common-padding-about'>
            <div className='common-container'>
              <h3>Example Educational Videos</h3>
              <div className='video-slider-flex video-slider-flex-flex'>
                <div className='common-container'>
                  <Slider {...settingsEducational}>
                    {edVideos.map((data, key) => (
                      <div className='video-slider-flex-inner full-height-block' key={key}>
                        <div className='video-slider'>
                          <CustomVideoPlayer
                            videoUrl={data?.src ? data?.src : ''}
                            className={'video'}
                            isPlaying={currentPlayingVideo === key}
                            onPlay={() => handleVideoPlay(key)}
                          />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </section>
          <section className='determine-block'>
            <div className='determine-block-img'>
              <img src='/images/determine-img.png' alt='img' />
            </div>
            <div className='common-container'>
              <div className='determine-block-text text-center'>
                <h3>
                  Do you want to know which BODY TYPE <br></br>you have?
                </h3>
                <button className='common-btn' onClick={() => navigate('/login')}>Take Our Assessment</button>
              </div>
            </div>
          </section>
          <section id="section2" className='trigger-block common-padding-about'>
            <div className='common-container'>
              <div className='common-title-block'>
                <h3><span>Sample</span> Trigger Point Library</h3>
                <p>
                  Search for the areas that hurt. And learn where the trigger points are that may be causing the{' '}
                  <span className='pl-1'>pain</span>. Click on a muscle to read the details on how each trigger point is
                  affected by your
                  <span className='pl-1'>BODY TYPE.</span> You can also watch 3D animation skeleton videos demonstrating
                  how to release the trigger point.
                </p>
              </div>
              <div className='trigger-block-search'>
                <Form className='search-block-custom'>
                  <Form.Control
                    onChange={(e) => {
                      handleSearchClickPain(e.target.value);
                    }}
                    type='search'
                    placeholder='Search'
                    className='me-2 rounded-pill'
                    aria-label='Search' />
                  <button>
                    <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M15.2713 14.9121L12.357 12.0064C13.2973 10.8085 13.8075 9.32921 13.8056 7.80636C13.8056 6.45015 13.4034 5.12439 12.65 3.99674C11.8965 2.86909 10.8255 1.99019 9.57257 1.47119C8.31959 0.95219 6.94085 0.816396 5.61069 1.08098C4.28054 1.34556 3.05871 1.99864 2.09972 2.95763C1.14073 3.91662 0.487654 5.13845 0.22307 6.4686C-0.0415146 7.79876 0.0942797 9.1775 0.61328 10.4305C1.13228 11.6835 2.01118 12.7544 3.13883 13.5079C4.26648 14.2613 5.59224 14.6635 6.94845 14.6635C8.4713 14.6654 9.95056 14.1552 11.1485 13.2149L14.0542 16.1292C14.1339 16.2096 14.2287 16.2733 14.3331 16.3168C14.4376 16.3604 14.5496 16.3828 14.6627 16.3828C14.7759 16.3828 14.8879 16.3604 14.9924 16.3168C15.0968 16.2733 15.1916 16.2096 15.2713 16.1292C15.3516 16.0495 15.4154 15.9547 15.4589 15.8503C15.5024 15.7458 15.5249 15.6338 15.5249 15.5206C15.5249 15.4075 15.5024 15.2955 15.4589 15.191C15.4154 15.0866 15.3516 14.9918 15.2713 14.9121ZM1.8056 7.80636C1.8056 6.7892 2.10722 5.79488 2.67232 4.94915C3.23743 4.10341 4.04063 3.44423 4.98037 3.05498C5.9201 2.66573 6.95416 2.56389 7.95178 2.76233C8.94939 2.96076 9.86576 3.45057 10.585 4.16982C11.3042 4.88906 11.7941 5.80543 11.9925 6.80304C12.1909 7.80066 12.0891 8.83472 11.6998 9.77445C11.3106 10.7142 10.6514 11.5174 9.80567 12.0825C8.95993 12.6476 7.96561 12.9492 6.94845 12.9492C5.58448 12.9492 4.27638 12.4074 3.31191 11.4429C2.34743 10.4784 1.8056 9.17033 1.8056 7.80636Z'
                        fill='black'
                      />
                    </svg>
                  </button>
                </Form>
                <div className="flex-block-data">
                  <div className="flex-block-data-inner">
                    <p><span>Preview</span> select visuals and
                      videos that show how pain
                      maps to common problem areas.</p>
                    <p>Want more? <br></br>
                      <MdLock size={30} color="grey" /><span>Unlock</span> the full library of 3D animations, pain patterns, and body type- specific insights with a subscription or program purchase.
                    </p>
                  </div>
                  <div className='trigger-block-search-flex'>
                    <>
                      {' '}
                      {
                        painPointData?.length > 0 ? (
                          painPointData.map((data, key) => {
                            if (data) {
                              if (key < 8) {
                                // Normal cards (first 8)
                                return (
                                  <div key={key} className='library-img-container-main-inner'>
                                    <div className='library-img-container-main common-box-height'>
                                      <Link
                                        className={"nav-link common-box-bg-all library-nav"}
                                        data-toggle="tab"
                                        to={`/trigger-pain-point/detail/${data?.id}`}
                                        role="tab"
                                      >
                                        <div className='library-img-container'>
                                          <div className='library-img-box'>
                                            <img
                                              src={data?.image ? data?.image : ''}
                                              alt={data?.title ? data?.title : ''}
                                              crossOrigin={cross_origin ? 'anonymous' : null}
                                              onContextMenu={(e) => e.preventDefault()}
                                            />
                                          </div>
                                          <div className='library-img-container-inner'>
                                            <div className='title-one pt-block'>{data?.title}</div>
                                            <div className='title-two'>{data?.title2}</div>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                );
                              } else {
                                // Locked cards (after 8)
                                return (
                                  <div key={key} className='library-img-container-main-inner'>
                                    <div className='library-img-container-main common-box-height locked'>
                                      <div style={{ cursor: 'pointer' }} className="nav-link common-box-bg-all library-nav" onClick={handleLoginPurchase}>
                                        <div className='library-img-container'>
                                          <div className='library-img-box' style={{ position: 'relative' }}>
                                            <img
                                              src={data?.image ? data?.image : ''}
                                              alt='Locked'
                                              style={{ filter: 'blur(4px)', opacity: 0.5 }}
                                              crossOrigin={cross_origin ? 'anonymous' : null}
                                              onContextMenu={(e) => e.preventDefault()}
                                            />
                                            <div className="lock-overlay">
                                              <MdLock size={30} color="grey" />
                                              <div className="lock-text-inner" style={{ marginTop: '8px', color: 'grey', fontWeight: 'bold' }}>
                                                Unlock to view more
                                              </div>
                                            </div>
                                          </div>
                                          <div className='library-img-container-inner locked-title'>
                                            <div className='title-one pt-block'>{data?.title}</div>
                                            <div className='title-two'>{data?.title2}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            }
                          })

                        ) : (
                          <div className='col-12 col-sm-12 col-md-12  col-lg-12 col-xl-12 '>
                            <div className={'library-empty-page'}>
                              <span className='itemsPerPagelabel'>Not Found</span>
                            </div>
                          </div>
                        )}
                    </>

                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className='determine-block'>
            <div className='determine-block-img'>
              <img src='/images/determine-img.png' alt='img' />
            </div>
            <div className='common-container'>
              <div className='determine-block-text text-center'>
                <h3>
                  Where you feel pain is rarely where <br></br>it is coming from
                </h3>
                <button className='common-btn' onClick={() => navigate('/login')}>Take Our Assessment</button>
              </div>
            </div>
          </section>
          <section id="section3" className='trigger-block common-padding-about'>
            <div className='common-container'>
              <div className='common-title-block'>
                <h3><span>Sample</span> Muscle Library</h3>
                <p>
                  Search for muscles that you want to learn about. Click on a muscle to read the details on how that
                  muscle is affected by your BODY TYPE. You can also watch 3D animation skeleton videos demonstrating
                  how to strengthen the muscle.
                </p>
              </div>
              <div className='trigger-block-search'>
                <Form className='search-block-custom'>
                  <Form.Control
                    onChange={(e) => {
                      handleSearchClick(e.target.value);
                    }}
                    type='search'
                    placeholder='Search'
                    className='me-2 rounded-pill'
                    aria-label='Search' />
                  <button>
                    <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M15.2713 14.9121L12.357 12.0064C13.2973 10.8085 13.8075 9.32921 13.8056 7.80636C13.8056 6.45015 13.4034 5.12439 12.65 3.99674C11.8965 2.86909 10.8255 1.99019 9.57257 1.47119C8.31959 0.95219 6.94085 0.816396 5.61069 1.08098C4.28054 1.34556 3.05871 1.99864 2.09972 2.95763C1.14073 3.91662 0.487654 5.13845 0.22307 6.4686C-0.0415146 7.79876 0.0942797 9.1775 0.61328 10.4305C1.13228 11.6835 2.01118 12.7544 3.13883 13.5079C4.26648 14.2613 5.59224 14.6635 6.94845 14.6635C8.4713 14.6654 9.95056 14.1552 11.1485 13.2149L14.0542 16.1292C14.1339 16.2096 14.2287 16.2733 14.3331 16.3168C14.4376 16.3604 14.5496 16.3828 14.6627 16.3828C14.7759 16.3828 14.8879 16.3604 14.9924 16.3168C15.0968 16.2733 15.1916 16.2096 15.2713 16.1292C15.3516 16.0495 15.4154 15.9547 15.4589 15.8503C15.5024 15.7458 15.5249 15.6338 15.5249 15.5206C15.5249 15.4075 15.5024 15.2955 15.4589 15.191C15.4154 15.0866 15.3516 14.9918 15.2713 14.9121ZM1.8056 7.80636C1.8056 6.7892 2.10722 5.79488 2.67232 4.94915C3.23743 4.10341 4.04063 3.44423 4.98037 3.05498C5.9201 2.66573 6.95416 2.56389 7.95178 2.76233C8.94939 2.96076 9.86576 3.45057 10.585 4.16982C11.3042 4.88906 11.7941 5.80543 11.9925 6.80304C12.1909 7.80066 12.0891 8.83472 11.6998 9.77445C11.3106 10.7142 10.6514 11.5174 9.80567 12.0825C8.95993 12.6476 7.96561 12.9492 6.94845 12.9492C5.58448 12.9492 4.27638 12.4074 3.31191 11.4429C2.34743 10.4784 1.8056 9.17033 1.8056 7.80636Z'
                        fill='black'
                      />
                    </svg>
                  </button>
                </Form>
                <div className="flex-block-data">
                  <div className="flex-block-data-inner">
                    <p><span>Preview</span> select visuals and
                      videos that show how pain
                      maps to common problem areas.</p>
                    <p>Want more? <br></br>
                      <MdLock size={30} color="grey" /><span>Unlock</span> the full library of 3D animations, pain patterns, and body type- specific insights with a subscription or program purchase.
                    </p>
                  </div>
                  <div className='trigger-block-search-flex'>
                    <>
                      {' '}
                      {
                        musclesAnatomyData?.length > 0 ? (
                          musclesAnatomyData.map((data, key) => {
                            if (data) {
                              if (key < 8) {
                                // Show first 8 normally
                                return (
                                  <div key={key} className='library-img-container-main-inner'>
                                    <div className='library-img-container-main common-box-height'>
                                      <Link
                                        className={'nav-link common-box-bg-all library-nav'}
                                        to={`/muscles-anatomy/detail/${data?.id}`}>
                                        <div className='library-img-container'>
                                          <div className='library-img-box'>
                                            <img
                                              src={data?.image ? data?.image : ''}
                                              alt={data?.title ? data?.title : ''}
                                              crossOrigin={cross_origin ? 'anonymous' : null}
                                              onContextMenu={(e) => e.preventDefault()}
                                            />
                                          </div>
                                          <div className='library-img-container-inner'>
                                            <div className='title-one pt-block'>{data?.title}</div>
                                            <div className='title-two'>{data?.title2}</div>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                );
                              } else {
                                // Locked cards
                                return (
                                  <div key={key} className='library-img-container-main-inner'>
                                    <div className='library-img-container-main common-box-height locked'>
                                      <div style={{ cursor: 'pointer' }} className="nav-link common-box-bg-all library-nav" onClick={handleLoginPurchase}>
                                        <div className='library-img-container'>
                                          <div className='library-img-box' style={{ position: 'relative' }}>
                                            <img
                                              src={data?.image ? data?.image : ''}
                                              alt='Locked'
                                              style={{ filter: 'blur(4px)', opacity: 0.5 }}
                                              crossOrigin={cross_origin ? 'anonymous' : null}
                                              onContextMenu={(e) => e.preventDefault()}
                                            />
                                            <div className="lock-overlay">
                                              <MdLock size={30} color="grey" />
                                              <div className="lock-text-inner" style={{ marginTop: '8px', color: 'grey', fontWeight: 'bold' }}>
                                                Unlock to view more
                                              </div>
                                            </div>
                                          </div>
                                          {/* Titles are still shown */}
                                          <div className='library-img-container-inner locked-title'>
                                            <div className='title-one pt-block'>{data?.title}</div>
                                            <div className='title-two'>{data?.title2}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            }
                          })
                        ) : (
                          <div className='col-12 col-sm-12 col-md-12  col-lg-12 col-xl-12 '>
                            <div className={'library-empty-page'}>
                              <span className='itemsPerPagelabel'>Not Found</span>
                            </div>
                          </div>
                        )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Modal
          show={show}
          onHide={handleClose}
          id='videoModal'
          centered
          className='modal fade custom-modal-style'
          aria-hidden='true'
          aria-labelledby='exampleModalLabel'
          size='xl'>
          <Modal.Header>
            <h4>Subscribe</h4>
            <button type='button' className='close' data-dismiss='modal' aria-label='Close' onClick={handleClose}>
              <span aria-hidden='true'>&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body >
            <div className='modal-body-custom'>
              <p className="text-block-sub">
                Subscribe now to unlock full access to detailed muscle visuals, pain patterns, educational videos and more.<br></br>Subscribe Now
              </p>

              <div className='center-block-btn'>
                <button onClick={() => navigate('/coming-soon')} className='common-btn-all-front' >Subscribe Now</button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </HomePage >
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => {
  return {

  };
};
export default connect(mapStateToProps, {})(AboutNewTwo);
